<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            scrollable
            :width="activeAccounts.length ? '950' : '500'">
            <v-card flat>
                <v-card-title>{{ $t('accounts_list') }}</v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="searchData"
                        ref="searchField" 
                        @keypress.enter="createdDataFetch"
                        :error="error.searchField.state"
                        :error-messages="error.searchField.message"
                        :loading="loading.search"
                        :label="$t('search')">
                    </v-text-field>
                    <v-data-table
                        v-if="activeAccounts.length"
                        v-model="selected.account"
                        @click:row="setSelected"
                        @dblclick:row="submit"
                        dense
                        :headers="headers.account"
                        :items="activeAccounts"
                        disable-pagination
                        hide-default-footer
                        single-select
                        show-select>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="submit" :disabled="!selected.account.length" text>{{ $t('btn_select') }}</v-btn>
                    <v-btn @click="close" text>{{ $t('close_btn') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import { mapActions } from 'vuex';
export default {
    name: "AccountSearchDialog",
    components: {
        RetryDialog
    },
    props: {
        search: {
            type: String,
            required: false
        },
        index: {
            type: Number,
            required: false
        },
        type: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            display: true,
            searchData: null,
            activeAccounts: [],
            loading: {
                search: false
            },
            selected: {
                account: []
            },
            error: {
                searchField: {
                    state: false,
                    message: null
                }
            },
            headers: {
                account: [
                    { text: this.$t('code'), value: 'formatted_code' },
                    { text: this.$t('account'), value: 'displayName' },
                    { text: this.$t('group'), value: 'category' },
                    { text: this.$t('account_type'), value:'type' }
                ]
            }
            
        }
    },
    computed: {
    },
    methods: {
        ...mapActions('accounting/activeAccount', ["fetchActiveAccounts"]),
        async createdDataFetch() {
            if(this.searchData) {
                this.loading.search = true;
                try {
                    this.clearError();
                    this.activeAccounts = [];
                    let result = await this.fetchActiveAccounts({ search: this.searchData.trim() });
                    this.activeAccounts = result.data;
                   
                    if(!this.activeAccounts.length) this.setError(this.$t('no_result'));
                    if(this.activeAccounts.length == 1) this.submit();
                    this.loading.search = false;
                } catch(error) {
                    this.loading.search = false;
                    let message = error.response ? error.response.data.message : 'Error: Network Error'; 
                    this.setError(message);
                }
            }
        },
        setError(message){
            this.error.searchField.state = true;
            this.error.searchField.message = message;
        },
        clearError(){
            this.error.searchField.state = false;
            this.error.searchField.message = null;
        },
        close() {
            this.$emit('close');
        } ,
        submit() {
            let selected;
            if(this.activeAccounts.length == 1) selected = this.activeAccounts[0];
            else selected = this.selected.account[0]; 
            let data = { index: this.index, selected }
            this.$emit('submit', data);
        },
        setSelected(item) {
            this.clearSelected();
            this.selected.account.push(item);
        },
        clearSelected() {
            this.selected.account = [];
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
    },
    created () {
        this.searchData = this._.clone(this.search);
        this.createdDataFetch();
    },
    updated() {
        this.$on('onSelectedSubmit', () => {
            this.submit();
        })
    }
}
</script>